// Helpers for multi-value text fields.
// Storage form: plain text where each non-empty line is one value.

export function toArray(value) {
  if (!value) return [];
  if (Array.isArray(value)) return value.filter(v => v && String(v).trim()).map(v => String(v).trim());
  return String(value)
    .split(/\n+/)
    .map(s => s.trim())
    .filter(Boolean);
}

export function toText(values) {
  if (!values) return '';
  if (Array.isArray(values)) return values.map(v => (v || '').trim()).filter(Boolean).join('\n');
  return String(values).trim();
}

export function addItem(currentText, newItem) {
  const arr = toArray(currentText);
  const trimmed = (newItem || '').trim();
  if (!trimmed) return currentText || '';
  arr.push(trimmed);
  return toText(arr);
}

export function removeItem(currentText, index) {
  const arr = toArray(currentText);
  arr.splice(index, 1);
  return toText(arr);
}

export function updateItem(currentText, index, newValue) {
  const arr = toArray(currentText);
  arr[index] = (newValue || '').trim();
  return toText(arr);
}

export const MULTI_VALUE_FIELDS = {
  audience: ['currently_doing', 'cost_of_current', 'gap', 'willing_to_give'],
  deal: ['real_cost']
};

export function isMultiValue(entityKind, fieldName) {
  return MULTI_VALUE_FIELDS[entityKind]?.includes(fieldName) || false;
}
